var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-04",
    clipPath: "url(#clip0_2773_3695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10 1.66699L11.6767 6.02623C11.9117 6.63726 12.0292 6.94277 12.2119 7.19975C12.3738 7.42751 12.5728 7.6265 12.8006 7.78845C13.0576 7.97118 13.3631 8.08869 13.9741 8.3237L18.3334 10.0003L13.9741 11.677C13.3631 11.912 13.0576 12.0295 12.8006 12.2122C12.5728 12.3741 12.3738 12.5731 12.2119 12.8009C12.0292 13.0579 11.9117 13.3634 11.6767 13.9744L10 18.3337L8.32339 13.9744C8.08838 13.3634 7.97088 13.0579 7.78815 12.8009C7.6262 12.5731 7.4272 12.3741 7.19944 12.2122C6.94246 12.0295 6.63695 11.912 6.02593 11.677L1.66669 10.0003L6.02592 8.3237C6.63695 8.08869 6.94246 7.97118 7.19944 7.78845C7.4272 7.6265 7.6262 7.42751 7.78815 7.19975C7.97088 6.94277 8.08838 6.63725 8.32339 6.02623L10 1.66699Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2773_3695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar04);
export default __webpack_public_path__ + "static/media/star-04.a7af297102c08abd3c4d7b21f73d8bae.svg";
export { ForwardRef as ReactComponent };